module.exports = __webpack_public_path__ + "static/media/4O.5a8b1003.png";